import React, { useEffect, useState } from "react";
import { Badge, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Label } from 'reactstrap';
import classnames from 'classnames';

// import * as firebase from "firebase";
import { Link } from "react-router-dom";
import { Tabs, Card } from "antd";

import { CardContent, Image, Segment } from "semantic-ui-react";

import Navigation from "../components/Navigation";
import Footer from '../components/Footer';
import { UserContext } from "../index";
import { Firestore } from "../config/firebase";

import Collections from "../Logic/collections/colections";
import CollectionsView from "../components/Collection";
import UpvoteDisplay from "../components/UpvotesDisplay";

export default function Allproduct(props) {
  const [activeTab, setActiveTab] = useState('1');

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  const [data, setData] = useState([]);
  useEffect(() => {
    // const user = Auth.currentUser;
    // console.log(Auth.currentUser);
    function fetchUpdates() {
      Firestore.collection("allProducts")
        .orderBy("createdAt", "desc")
        .get()
        .then(function(querySnapshot) {
          let docs = [];
          querySnapshot.forEach(function(doc) {
            docs.push({ ...doc.data(), id: doc.id });
            // doc.data() is never undefined for query doc snapshots
          });

          setData(docs);
        });
    }
    fetchUpdates();
  }, []);



  return (
    <UserContext.Consumer>
      {value => (
        <>
          <Navigation />

          <Col lg={11} className="ml-auto mr-auto">
            <Card className="mb-3 mt-3" style={{ minHeight: "500px" }}>
              <CardContent>
              <div>
      <Nav pills>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { toggle('1'); }}
          >
            ALL
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '2' })}
            onClick={() => { toggle('2'); }}
          >
            EVENTS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '3' })}
            onClick={() => { toggle('3'); }}
          >
            BOUNTY
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '4' })}
            onClick={() => { toggle('4'); }}
          >
            INVESTOR FOCUS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '5' })}
            onClick={() => { toggle('5'); }}
          >
            FUNDING ALERTS
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '6' })}
            onClick={() => { toggle('6'); }}
          >
            DE-FI
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '7' })}
            onClick={() => { toggle('7'); }}
          >
            STARTUP
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '8' })}
            onClick={() => { toggle('8'); }}
          >
            LAUNCH
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '9' })}
            onClick={() => { toggle('9'); }}
          >
            EDUCATION
          </NavLink>
        </NavItem>

        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === '10' })}
            onClick={() => { toggle('10'); }}
          >
            INFOGRAPHICS
          </NavLink>
        </NavItem>

      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <Row>
            <Col sm="12">
             
        {data &&
          data.map((item, index) => (
            <div className="">

          <Segment.Group horizontal   key={index}>
              <Segment style={{width: '10px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
              <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
               <b>{item.Highlight}</b> <br/>   
               {item.Type && item.Type.map((item) => (
                  <>
                      <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
            
                  </>
                ))}
              </Segment>
              <Segment style={{textAlign: 'right'}}>
              <UpvoteDisplay history={props.history} postID={item.id} />
              <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
              </Segment>
            </Segment.Group>
             </div>
          ))}
            </Col>
          </Row>
        </TabPane>


        <TabPane tabId="2">
        {data &&
          data.map((item, index) => (
            <>
              {item.Type.find(Event => Event == 'Event') ? (
                 <Segment.Group horizontal   key={index}>
                 <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                 <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                  <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                 </Segment>
                 <Segment style={{textAlign: 'right'}}>
                 <UpvoteDisplay history={props.history} postID={item.id} />
                 <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  /> 
                 
                 </Segment>
               </Segment.Group>
              ) : (
                ""
              )}
            </>
          ))}
        </TabPane>

        <TabPane tabId="3">
        {data &&
          data.map((item, index) => (
            <>
              {item.Type.find(Event => Event == 'Bounty') ? (
                 <Segment.Group horizontal   key={index}>
                 <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                 <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                  <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                 </Segment>
                 <Segment style={{textAlign: 'right'}}>
                 <UpvoteDisplay history={props.history} postID={item.id} />
                 <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                 
                 </Segment>
               </Segment.Group>
              ) : (
                ""
              )}
            </>
          ))}
        </TabPane>

        <TabPane tabId="4">
        {data &&
          data.map((item, index) => (
            <>
              {item.Type.find(Investor => Investor == 'Investor Focus') ? (
                 <Segment.Group horizontal   key={index}>
                 <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                 <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                  <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                 </Segment>
                 <Segment style={{textAlign: 'right'}}>
                 <UpvoteDisplay history={props.history} postID={item.id} />
                 <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                 </Segment>
               </Segment.Group>
              ) : (
                ""
              )}
            </>
          ))}
        </TabPane>

        <TabPane tabId="5">
        {data &&
          data.map((item, index) => (
            <>
              {item.Type.find(Event => Event == 'Funding') ? (
                 <Segment.Group horizontal   key={index}>
                 <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                 <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                  <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                              <>
                                                  <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                        
                                              </>
                                            ))}
                 </Segment>
                 <Segment style={{textAlign: 'right'}}>
                 <UpvoteDisplay history={props.history} postID={item.id} />
                 <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                 </Segment>
               </Segment.Group>
              ) : (
                ""
              )}
            </>
          ))}
        </TabPane>

        <TabPane tabId="6">

            {data &&
              data.map((item, index) => (
                <>
                  {item.Type.find(Event => Event == 'De-Fi') ? (
                     <Segment.Group horizontal   key={index}>
                     <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                     <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                      <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                                  <>
                                                      <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                            
                                                  </>
                                                ))}
                     </Segment>
                     <Segment style={{textAlign: 'right'}}>
                     <UpvoteDisplay history={props.history} postID={item.id} />
                     <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                     </Segment>
                   </Segment.Group>
                  ) : (
                    ""
                  )}
                </>
              ))}
        </TabPane>

        <TabPane tabId="7">
        
        {data &&
              data.map((item, index) => (
                <>
                  {item.Type.find(Startup => Startup == 'Startup') ? (
                     <Segment.Group horizontal   key={index}>
                     <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                     <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                      <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                                  <>
                                                      <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                            
                                                  </>
                                                ))}
                     </Segment>
                     <Segment style={{textAlign: 'right'}}>
                     <UpvoteDisplay history={props.history} postID={item.id} />
                     <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                     </Segment>
                   </Segment.Group>
                  ) : (
                    ""
                  )}
                </>
              ))}
        </TabPane>

        <TabPane tabId="8">
        {data &&
              data.map((item, index) => (
                <>
                  {item.Type.find(Startup => Startup == 'Launch') ? (
                     <Segment.Group horizontal   key={index}>
                     <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                     <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                      <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                                  <>
                                                      <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                            
                                                  </>
                                                ))}
                     </Segment>
                     <Segment style={{textAlign: 'right'}}>
                     <UpvoteDisplay history={props.history} postID={item.id} />
                     <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                     </Segment>
                   </Segment.Group>
                  ) : (
                    ""
                  )}
                </>
              ))}
      
        </TabPane>

        <TabPane tabId="9">
        {data &&
              data.map((item, index) => (
                <>
                  {item.Type.find(Startup => Startup == 'Education') ? (
                     <Segment.Group horizontal   key={index}>
                     <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                     <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                      <b>{item.Highlight}</b> <br/>   {item.Type && item.Type.map((item) => (
                                                  <>
                                                      <Badge href="#" style={{marginRight: 5}} color="primary">{item}</Badge>
                                            
                                                  </>
                                                ))}
                     </Segment>
                     <Segment style={{textAlign: 'right'}}>
                     <UpvoteDisplay history={props.history} postID={item.id} />
                     <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                     </Segment>
                   </Segment.Group>
                  ) : (
                    ""
                  )}
                </>
              ))}

   
        </TabPane>

        <TabPane tabId="10">
        {data &&
              data.map((item, index) => (
                <>
                  {item.Type.find(Startup => Startup == 'Infograpics') ? (
                     <Segment.Group horizontal   key={index}>
                     <Segment style={{width: '100px', }}> <Image style={{width: 60}} src={item.imageAsFile} /></Segment>
                     <Segment style={{flexWrap: 'wrap', width: '60%'}}> <h3><Link to={`/allproduct/${item.id}`}>  {item.Title} </Link></h3>
                      <b>{item.Highlight}</b> <br/>    
                      {item.Type && item.Type.map((item) => (
                                                  <>
                                                      <Badge href="#" style={{marginRight: 5}} color="primary"> test  {item}</Badge>
                                            
                                                  </>
                                                ))}
                     </Segment>
                     <Segment style={{textAlign: 'right'}}>
                     <UpvoteDisplay history={props.history} postID={item.id} />
                     <CollectionsView  history={props.history}  id={item.id}  action={() =>  Collections.create(item.id)  }  />  
                     </Segment>
                   </Segment.Group>
                  ) : (
                    ""
                  )}
                </>
              ))}
      
        </TabPane>
      </TabContent>
    </div>
               </CardContent>
            </Card>
          </Col>

          <Footer/>
        </>
      )}
    </UserContext.Consumer>
  );
}
